<template>
  <div class="chat-card">
    <!-- {{ props.message.eventName }} -->
    <div :class="props.message.styles.isUser ? 'message-user' : 'message-bot'">
      <!-- <div class="message-header">
        <div class="message-info">
          <img
            v-if="props.message.styles.isBot"
            alt="机器人头像"
            class="message-avatar"
            :src="props.botInfo.botAvatar"
          />
          <span v-else-if="props.message.styles.isUser" class="user-icon">👤</span>
          <span v-if="props.message.styles.isTranscribing" class="transcribing-indicator">
            🎤 正在转录...
          </span>
          <span v-if="props.message.styles.isStreaming" class="streaming-indicator">
            🤖 正在回复...
          </span>
        </div>
      </div> -->
      <div class="message-content">
        <!-- 普通文本内容 -->
        <span v-if="props.message.data?.data?.content">{{ props.message.data.data.content }}</span>
        <span v-if="props.message.styles.isStreaming" class="typing-indicator">|</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, defineProps } from 'vue'
// props
const props = defineProps({
  message: {
    type: Object,
    default: () => ({}),
    required: true
  },
  botInfo: {
    type: Object,
    default: () => ({
      botId: '',
      botAvatar: ''
    }),
    required: true
  }
})
// data
const data = ref({})
// computed
const dataControl = computed(() => data)
// lice-cycle
onMounted(() => {
  console.log('dataControl', dataControl.value)
})
</script>

<style lang="less" scoped>
.chat-card {
  width: 100%;
  // padding: 0 20px;
  // margin-bottom: 16px;

  .message-content {
    font-size: 14px;
    line-height: 20px;
    color: #323233;
    max-width: 70%;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
}

// 用户消息样式
.message-user {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  // margin-bottom: 8px;

  // .message-header {
  //   margin-bottom: 8px;

  //   .message-info {
  //     display: flex;
  //     align-items: center;
  //     gap: 8px;
  //     color: #1890ff;
  //     font-weight: bold;
  //     font-size: 14px;

  //     .user-icon {
  //       font-size: 16px;
  //     }

  //     .transcribing-indicator {
  //       color: #faad14;
  //       font-size: 12px;
  //       animation: pulse 1.5s infinite;
  //       font-weight: normal;
  //       margin-left: 8px;
  //     }
  //   }
  // }

  .message-content {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 10px 12px;
  }
}

// 机器人消息样式
.message-bot {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // margin-bottom: 8px;

  // .message-header {
  //   margin-bottom: 8px;

  //   .message-info {
  //     display: flex;
  //     align-items: center;
  //     gap: 8px;
  //     color: #52c41a;
  //     font-weight: bold;
  //     font-size: 14px;

  //     .message-avatar {
  //       width: 24px;
  //       height: 24px;
  //       border-radius: 50%;
  //       flex-shrink: 0;
  //     }

  //     .transcribing-indicator {
  //       color: #faad14;
  //       font-size: 12px;
  //       animation: pulse 1.5s infinite;
  //       font-weight: normal;
  //       margin-left: 8px;
  //     }

  //     .streaming-indicator {
  //       color: #1890ff;
  //       font-size: 12px;
  //       animation: pulse 1.5s infinite;
  //       font-weight: normal;
  //       margin-left: 8px;
  //     }
  //   }
  // }

  .message-content {
    line-height: 20px;
    // background-color: #f6ffed;
    // border: 1px solid #b7eb8f;
    // border-radius: 18px 18px 18px 4px;
    // padding: 12px 16px;
    // max-width: 70%;
    // word-wrap: break-word;
    // box-shadow: 0 2px 8px rgba(82, 196, 26, 0.1);
    // white-space: pre-wrap;

    .typing-indicator {
      animation: blink 1s infinite;
      color: #52c41a;
      font-weight: bold;
    }
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@keyframes blink {
  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}
</style>
